<template>
  <img
    v-if="hasLogo"
    class="v-toolbar-logo"
    :src="logoUrl"
    :style="{
      height: styles.height
    }"
  />
  <div v-else class="v-toolbar__text">{{ fallbackText }}</div>
</template>

<script>
import { isPresent, getImageUrl } from "@/lib/utils"

export const DEFAULT_STYLES = { height: "50%" }

export default {
  props: {
    logo: { type: Object, default: () => ({}) },
    fallbackText: { type: String, default: "" },
    styles: { type: Object, default: () => DEFAULT_STYLES }
  },

  computed: {
    hasLogo() {
      return isPresent(this.logo)
    },

    logoUrl() {
      return getImageUrl(this.logo)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.v-toolbar-logo {
  max-height: 100%;
  max-width: 100%;
  align-self: center;
  max-height: $toolbar--height;
}
</style>
